import { createFileRoute, useParams } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { OvertimeApprovalDetailPage } from "@/components/supervisor/overtime/OvertimeApprovalDetailPage";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/supervisor/_layout/overtime-approvals_/$id")({
  beforeLoad: () => {
    // Not gated on overtime_approval_required: the backend lists and decides
    // these claims either way, and claims still route here with it off (T-165).
    requireFeature("attendance");
  },
  component: SupervisorOvertimeApprovalDetail,
});

function SupervisorOvertimeApprovalDetail() {
  const { id } = useParams({
    from: "/supervisor/_layout/overtime-approvals_/$id",
  });
  return (
    <SidebarInset>
      <DashboardHeader current={"Overtime Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <OvertimeApprovalDetailPage approvalId={id} />
      </div>
    </SidebarInset>
  );
}
